module.exports = __webpack_public_path__ + "app/principal/modals/modal-confirm-pdp-conflict-2qQhPPdX.html";